import {combineReducers} from "redux";
import app from "./app";
import domain from "./domain";
import ui from "./ui";

const rootReducer = combineReducers({
    app: app,
    domain: domain,
    ui: ui,
})

export default rootReducer


export const getVisibleDoctypes = (state) => {

    let visibleDoctypes = []
    if (state.domain.doctypeIdsByWrlevelName[getSelectedLevelName(state)]) {
        visibleDoctypes = state.domain.doctypeIdsByWrlevelName[getSelectedLevelName(state)].map(doctypeId => (
            state.domain.doctypesById[doctypeId]
        ))
    }

    if (state.domain.doctypesQueue.length === 0) {
        return visibleDoctypes
    }

    const visibleDoctypesIds = visibleDoctypes.map(doctype => doctype.id)
    let queued = []
    state.domain.doctypesQueue.map(doctypeId => {
        if (visibleDoctypesIds.includes(doctypeId)) {
            queued.push(state.domain.doctypesById[doctypeId])
        }
    })

    return queued
}

export const isDoctypeCoverLetter = (state) => {
    return state.domain.coverLetterDoctypeIds.includes(state.app.orderDetails.selectedDoctypeId)
}

export const getCurrencySymbol = (state) => {
    switch (state.app.orderDetails.selectedCurrency) {
        case 'USD':
            return '$'
        case 'EUR':
            return '€'
        case 'GBP':
            return '£'
        case 'AUD':
            return 'A$'
    }
}
export const getCurrencySymbols = (state) => ({
    'USD':'$',
    'EUR':'€',
    'GBP':'£',
    'AUD':'A$'
})

export const getDoctypesPrices = (state) => {
    return calculateDoctypesPrices(state)
}

export const getDoctypesById = (state) => state.domain.doctypesById

export const getSelectedDoctypeId = (state) => {
    return state.app.orderDetails.selectedDoctypeId
}

export const getSelectedDoctype = (state) => state.domain.doctypesById[state.app.orderDetails.selectedDoctypeId]


export const getCoverLetters = (state) => {
    return state.domain.coverLetters
}

export const getSelectedCoverLettersCount = (state) => {
    return state.app.orderDetails.selectedCoverLettersCount
}

export const getUrgencies = (state) => {
    return state.domain.urgencies
}

export const getSelectedUrgencyId = (state) => {
    return state.app.orderDetails.selectedUrgencyId
}


export const getVisibleLevels = (state) => {
    if (state.domain.wrlevelsByDoctypeId[getSelectedDoctypeId(state)]) {
        return state.domain.wrlevelsByDoctypeId[getSelectedDoctypeId(state)]
    }
    return []
}

export const getLevelsDescriptions = (state) => {
    return state.domain.wrlevelsDescriptionsByName
}

export const getSelectedLevelId = (state) => {
    return getSelectedLevel(state).id
}

export const getSelectedLevelName = (state) => {
    return state.app.orderDetails.selectedLevelName
}

export const getSelectedLevel = (state) => {
    const levels = getVisibleLevels(state)
    const selcetedLevelName = getSelectedLevelName(state)
    const selectedLevel = levels.filter(level => selcetedLevelName === level.name)
    if (selectedLevel[0]) {
        return selectedLevel[0]
    } else {
        return {
            id: null,
            name: 'Null',
        }
    }
}


export const getVases = (state) => {
    return state.domain.vases
}

export const getVasesPrices = (state) => {
    return calculateVasesPrices(state)
}

export const getSelectedVasIds = (state) => {
    return state.app.orderDetails.selectedVasIds
}

export const getSelectedVasItems = (state) => {
    return state.app.orderDetails.selectedVasItems
}

export const getTotal = (state) => {
    return calculateTotal(state)
}

export const getDiscountCode = (state) => {
    return state.app.orderDetails.discountCode
}

export const getDiscountValue = (state) => {
    return calculateDiscountValue(state)
}

export const getDiscountPercent = (state) => {
    return state.app.orderDetails.discountPercent
}

export const isDiscountValid = (state) => {
    return state.app.orderDetails.isDiscountValid
}

export const needDiscountInitialCheck = (state) => {
    return state.app.orderDetails.needDiscountInitialCheck
}

export const getFilledTargetPosition = (state) => {
    return state.app.personalInfo.filledTargetPosition
}

export const getFilledEmail = (state) => {
    return state.app.personalInfo.filledEmail
}

export const getFilledRetypeEmail = (state) => {
    return state.app.personalInfo.filledRetypeEmail
}

export const getFilledName = (state) => {
    return state.app.personalInfo.filledName
}

export const getFilledPhoneNumber = (state) => {
    return state.app.personalInfo.filledPhoneNumber
}

export const isAcceptTerms = (state) => {
    return state.app.acceptTerms
}

export const issetErrorForField = (field, state) => {
    return !!state.app.validationErrors[field]
}

export const getErrorForField = (field, state) => {
    return state.app.validationErrors[field]
}

export const issetValidationErrors = (state) => {
    return Object.keys(state.app.validationErrors).length > 0
}

export const getCountValidations = (state) => {
    return state.app.countValidations
}

export const getCountries = (state) => {
    return state.domain.countries
}

export const getSelectedCountryId = (state) => {
    return state.app.personalInfo.selectedCountry
}

export const getCurrencies = (state) => {
    return state.domain.currencies
}

export const getSelectedCurrency = (state) => {
    return state.app.orderDetails.selectedCurrency
}

export const isCusotomerLoggedIn = (state) => {
    return state.app.personalInfo.isCusotomerLoggedIn
}

export const getSelectedPaymentMethod = (state) => {
    return state.app.selectedPaymentMethod
}



function calculateTotal(state) {
    return round(calculateForDoctype(getSelectedDoctypeId(state), state) + calculateVasesTotal(state));
}

function calculateDoctypesPrices(state) {
    let doctypesPrices = {}

    state.domain.doctypes.map((doctype) => {
        doctypesPrices[doctype.id] = calculateForDoctype(parseInt(doctype.id), state)
    })

    return doctypesPrices;
}

function calculateForDoctype(doctypeId, state) {
    const selectedLevelId = getSelectedLevelId(state)
    const selectedUrgencyId = getSelectedUrgencyId(state)
    const coverLetterDoctypeIds = state.domain.coverLetterDoctypeIds
    const selectedCoverLettersCount = getSelectedCoverLettersCount(state)
    const coverLetterPrice = state.domain.coverLetterPrice
    const selectedCurrency = getSelectedCurrency(state)
    const pricesByDoctypeLevelUrgency = state.domain.prices

    if (pricesByDoctypeLevelUrgency[doctypeId]
        && pricesByDoctypeLevelUrgency[doctypeId][selectedLevelId]
        && pricesByDoctypeLevelUrgency[doctypeId][selectedLevelId][selectedUrgencyId])
    {
        let price = pricesByDoctypeLevelUrgency[doctypeId][selectedLevelId][selectedUrgencyId][0];

        if (coverLetterDoctypeIds.includes(doctypeId) && selectedCoverLettersCount > 0) {
            price = price + (coverLetterPrice * (selectedCoverLettersCount - 1))
        }

        const priceInCurrency = price * getCurrencyRate(state, selectedCurrency);

        return round(priceInCurrency);
    }

    return 0
}

function calculateVasesPrices(state) {
    let vasesPrices = {}

    Object.keys(state.domain.vases).map((vasId) => {
        vasesPrices[vasId] = calculateForVas(vasId, state)
    })

    return vasesPrices;
}

function calculateForVas(vasId, state) {

    const KSA = '80'
    const KSC = '302'
    const selectedVasItems = getSelectedVasItems(state)

    let price = parseFloat(state.domain.vases[vasId].price);


    if (vasId == KSA) {
        if (selectedVasItems[vasId] && selectedVasItems[vasId] > 1) {
            const additionalItemPrice = 30;
            // additional item is more than 1
            // 1 item is equal base price
            price = price + ((selectedVasItems[vasId] - 1) * additionalItemPrice);
        }
    }

    if (vasId == KSC) {
        if (selectedVasItems[vasId] && selectedVasItems[vasId] > 1) {
            price = price * selectedVasItems[vasId];
        }
    }

    const priceInCurrency = price * getCurrencyRate(state, getSelectedCurrency(state));

    return round(priceInCurrency)
}

function calculateVasesTotal(state) {

    let vasesPrice = 0
    getSelectedVasIds(state).forEach(function(vasId) {
        vasesPrice = vasesPrice + calculateForVas(vasId, state)
    })

    return vasesPrice
}

function calculateDiscountValue(state) {

    const value = (calculateForDoctype(getSelectedDoctypeId(state), state) * getDiscountPercent(state)) / 100

    return round(value);
}

function round(price) {
    return +((Math.round(price * 100) / 100).toFixed(2))
}


function getCurrencyRate(state, currency) {
    return state.domain.currencyRates.USD[currency]
}
